export default __webpack_public_path__ + "static/media/c002-PPII-10.e75f3ac2.svg";